<template>
  <div class="attributes_wrap">
    <el-form
        :model="formAttributes"
        :rules="rules"
        ref="form"
    >
        <!-- <div class="multipleSelectAttrWrap">
            <MultipleSelectAttr 
                v-for="(item) in compositionAttrList" 
                :key="item.attributeId"
                v-model="formAttributes[item.attributeId]" 
                :attrData="item"
                :formdata="formdata"
                :attributeList="item.attributeValueInfoList"
                @valid="valid"
            />
        </div> -->
        <div style="margin-top: 10px;" v-if="requiredAttr.length">重要属性</div>
        <div class="attributes_list">
            <div 
                class="attributes_item" 
                :class="item.attributeMode === 4 ? 'w100' : ''"
                v-for="(item) in requiredAttr" 
                :key="item.attributeId"
            >
                <MultipleSelectAttr 
                    v-if="item.attributeType === 3 && item.attributeMode === 4"
                    :key="item.attributeId"
                    v-model="formAttributes[item.attributeId]" 
                    :attrData="item"
                    :formdata="formdata"
                    :attributeList="item.attributeValueInfoList"
                    @valid="valid"
                    @selectChange="(val) => addCustomProp(item.attributeId,val,item.attributeValueInfoList)"
                />
                <div class="attributes_content" v-else>
                    <el-form-item 
                        :label="item.attributeName" 
                        label-position="top" 
                        :prop="item.attributeId+''" 
                        :key="item.attributeId"
                    >
                        <el-input 
                            v-if="item.attributeMode === 0" 
                            v-model="formAttributes[item.attributeId]" 
                            placeholder="请输入" 
                            width="100%" 
                            clearable
                        />
                        <el-select 
                            v-if="[1,2,3].includes(item.attributeMode)"
                            v-model="formAttributes[item.attributeId]" 
                            placeholder="请选择" 
                            width="100%" 
                            clearable
                            filterable
                            allow-create
                            :multiple="item.attributeMode === 1" 
                            :multiple-limit="item.attributeInputNum"
                            @change="(val) => addCustomProp(item.attributeId,val,item.attributeValueInfoList)"
                        >
                            <el-option
                                v-for="o in item.attributeValueInfoList"
                                :key="o.attributeValueId"
                                :label="o.attributeValue"
                                :value="o.attributeValueId"
                            >
                            </el-option>
                        </el-select>
                        <MultipleSelectAndInput 
                            v-if="item.attributeMode === 4"
                            v-model="formAttributes[item.attributeId]" 
                            :formdata="formdata"
                            :attributeList="item.attributeValueInfoList"
                            @valid="valid"
                            @selectChange="(val) => addCustomProp(item.attributeId,val,item.attributeValueInfoList)"
                        />
                    </el-form-item>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px;" v-if="otherAttrList.length">其他属性</div>
        <div class="attributes_list">
            <div 
                class="attributes_item" 
                :class="item.attributeMode === 4 ? 'w100' : ''"
                v-for="(item) in otherAttrList" 
                :key="item.attributeId"
            >
                <MultipleSelectAttr 
                    v-if="item.attributeType === 3 && item.attributeMode === 4"
                    :key="item.attributeId"
                    v-model="formAttributes[item.attributeId]" 
                    :attrData="item"
                    :formdata="formdata"
                    :attributeList="item.attributeValueInfoList"
                    @valid="valid"
                    @selectChange="(val) => addCustomProp(item.attributeId,val,item.attributeValueInfoList)"
                />
                <div class="attributes_content" v-else>
                    <el-form-item 
                        :label="item.attributeName" 
                        label-position="top" 
                        :prop="item.attributeId+''" 
                        :key="item.attributeId"
                    >
                        <el-input 
                            v-if="item.attributeMode === 0" 
                            v-model="formAttributes[item.attributeId]" 
                            placeholder="请输入" 
                            width="100%" 
                            clearable
                        />
                        <el-select 
                            v-if="[1,2,3].includes(item.attributeMode)"
                            v-model="formAttributes[item.attributeId]" 
                            placeholder="请选择" 
                            width="100%" 
                            clearable
                            filterable
                            allow-create
                            :multiple="item.attributeMode === 1" 
                            :multiple-limit="item.attributeInputNum"
                            @change="(val) => addCustomProp(item.attributeId,val,item.attributeValueInfoList)"
                        >
                            <el-option
                                v-for="o in item.attributeValueInfoList"
                                :key="o.attributeValueId"
                                :label="o.attributeValue"
                                :value="o.attributeValueId"
                            >
                            </el-option>
                        </el-select>
                        <MultipleSelectAndInput 
                            v-if="item.attributeMode === 4"
                            v-model="formAttributes[item.attributeId]" 
                            :formdata="formdata"
                            :attributeList="item.attributeValueInfoList"
                            @valid="valid"
                            @selectChange="(val) => addCustomProp(item.attributeId,val,item.attributeValueInfoList)"
                        />
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
    <div style="text-align: center;margin-top: 20px;" v-if="attrList.length > (requiredAttr.length + 2)">
        <el-link :icon="isShowAll ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" :underline="false" @click="isShowAll = !isShowAll">{{isShowAll ? '收起' : '展开所有属性'}} </el-link>
    </div>
  </div>
</template>
<script>
import { genericAttributeValidate } from './rulesValidate.js'
import MultipleSelectAttr from './MultipleSelectAttr.vue'
import MultipleSelectAndInput from './MultipleSelectAndInput.vue'
import { addCustomAttribute } from '@/servers/prod/center/shein.js';
const compositionRatioItem = {
    material:'',
    ratio:0
}
export default {
  components: {
    MultipleSelectAndInput,
    MultipleSelectAttr
  },
  props: {
    formdata:{
        type: Object,
        default: () => {
            return {};
        }
    },
    // 所有属性
    attrList:{
        type:Array,
        default:()=>{
            return []
        }
    },
    attrListMap:{
        type:Object,
        default:()=>{
            return {}
        }
    },
    // 普通属性
    genericAttrList:{
        type:Array,
        default:()=>{
            return []
        }
    },
    // 成分属性
    compositionAttrList:{
        type:Array,
        default:()=>{
            return []
        }
    },
    // 可以添加自定义属性的配置
    customAttributeCfg:{
        type:Object,
        default:()=>{
            return {}
        }
    },
  },
  data() {
    return {
        formAttributes:{},
        materialList:[],
        tableData:[{...compositionRatioItem}],
        attributesList:[
            {
                label:'材质',
                subtitle:'Composition',
                required:true,
                type:'select',
                options:[],
                value:''
            },
            {
                label:'材质',
                subtitle:'Composition',
                required:true,
                type:'select',
                options:[],
                value:''
            },
            {
                label:'材质',
                subtitle:'Composition',
                required:true,
                type:'select',
                options:[],
                value:''
            },
            {
                label:'材质',
                subtitle:'Composition',
                required:true,
                type:'select',
                options:[],
                value:''
            },
        ],
        isShowAll:false, // 是否展示所有属性
        rules: {},
    };
  },
  watch: {
    attrList:{
        handler(v){
            this.initRules();
            // this.$nextTick(() => {
            //     this.valid()
            // })
        },
        immediate: true
    },
    attrListMap:{
        handler(v){
            if(v){
               this.initAttr(); 
            }
        },
        deep:true,
        immediate: true
    },
  },
  computed: {
    shopId() {
      return this.$store.getters.shops_getCategoryPropShopId('shein')
    },
    requiredAttr(){
        let list = [...this.compositionAttrList,...this.genericAttrList];
        list = list.filter(i => i.attributeStatus === 3)
        return list
    },
    otherAttrList(){
        let list = [...this.compositionAttrList,...this.genericAttrList];
        list = list.filter(i => i.attributeStatus !== 3)
        if(this.isShowAll){
            return list
        }else{
            return list.slice(0, 2)
        }
    }
  },

  methods: {
    initRules(){
        this.attrList.forEach(item => {
            let attrKey = item.attributeId
            if(item.attributeStatus === 3){ // 必填属性
                this.rules[attrKey]=[{required: true,validator:genericAttributeValidate(item,this.formAttributes), trigger: ['blur','change']}]
            }else if(item.attributeType === 3){ // 成分属性
                this.rules[attrKey]=[{required: false,validator:genericAttributeValidate(item,this.formAttributes), trigger: ['blur','change']}]
            }
        })
    },
    getAttr(){
        let result = [];
        for(let key in this.formAttributes){
            let item = this.formAttributes[key];
            let attrObj = this.attrListMap[key];
            let valueList = attrObj.attributeValueInfoList || [];

            if(!item || item.length == 0){
                continue;
            }
            if(Array.isArray(item)){ // 多选
                item.forEach(i => {
                    let obj = {
                        attributeId:key,
                        attributeMultiList:[{
                            attributeName:attrObj.attributeName
                        }],
                        attributeValueId:null,
                        attributeValueMultiList:[]
                    }
                    let valueObj = {};
                    if(typeof i === 'object'){ // 多选+输入框
                        valueObj = valueList.find(v => v.attributeValueId === i.key) || {};
                        obj.attributeValueId = i.key
                        obj.attributeValue = i.value
                    }else{// 纯多选
                        valueObj = valueList.find(v => v.attributeValueId === i) || {};
                        obj.attributeValueId = i
                    }
                    obj.attributeValueMultiList = [{attributeValueName:valueObj.attributeValue}]
                    result.push(obj)
                })
            }else{
                let obj = {
                    attributeId:key,
                    attributeMultiList:[
                        {
                            attributeName:attrObj.attributeName
                        }
                    ],
                    attributeValueId:null,
                    attributeValueMultiList:[]
                }
                if(typeof item === 'number'){ // 单选
                    let valueObj = valueList.find(i => i.attributeValueId === item) || {};
                    obj.attributeValueId = item
                    obj.attributeValueMultiList = [{attributeValueName:valueObj.attributeValue}]
                }else{
                    obj.attributeValueId = null
                    obj.attributeValue = item
                    obj.attributeValueMultiList = []
                }
                result.push(obj)
            }
        }
        return result;
    },
    initAttr(){
        let itemPropValues = this.formdata.itemPropValues || [];
        this.formAttributes = {};
        if(itemPropValues && itemPropValues.length > 0){// 赋值初始值
            itemPropValues.forEach(item => {
                let attributeId = item.attributeId
                let attrObj = this.attrListMap[attributeId] || {};
                if(attrObj.attributeMode === 0){ // 输入框
                    this.$set(this.formAttributes, attributeId, item.attributeValue)
                }else if([2,3].includes(attrObj.attributeMode)){ // 下拉框单选
                    this.$set(this.formAttributes, attributeId, +item.attributeValueId)
                }else if(attrObj.attributeMode === 1){// 下拉框多选
                    if(this.formAttributes[attributeId]){
                        let arr = [...this.formAttributes[attributeId],+item.attributeValueId]
                        this.$set(this.formAttributes, attributeId, arr)
                    }else{
                        this.$set(this.formAttributes, attributeId, [+item.attributeValueId])
                    }
                }else if(attrObj.attributeMode === 4){// 下拉框多选 + 输入框
                    let obj = {
                        key:+item.attributeValueId,
                        value:item.attributeValue
                    }
                    if(this.formAttributes[attributeId]){
                        let arr = [...this.formAttributes[attributeId],obj]
                        this.$set(this.formAttributes, attributeId, arr)
                    }else{
                        this.$set(this.formAttributes, attributeId, [obj])
                    }
                }
            })
        }
        this.valid();
    },
    valid() {
        return new Promise((resolve) => {
            this.$nextTick(() => {
                this.$refs.form.validate(valid => {
                    resolve(valid);
                })
            })
        })
    },
    addCustomProp(attributeId,val,attrList){
        let obj = attrList.find(item => item.attributeValueId === val)
        console.log('this.formAttributes:',this.formAttributes)
        if(this.customAttributeCfg[attributeId] && !obj){
            addCustomAttribute({
                attributeId:attributeId,
                attributeValue:val,
                categoryId:this.formdata.categoryId,
                attributeValueNameMultis:[{
                    language:'zh-cn',
                    attributeValueNameMulti:val
                }]
            },this.shopId).then(res => {
                this.$emit('getPropsList')
                if(res.result === 1){
                    let data = res.data;
                    let attrObj = this.attrListMap[attributeId];
                    let attributeValueId = data?.info?.attributeValueId;
                    this.$emit('getPropsList',() => {
                        // 新增自定义属性后回现处理
                        if(attrObj.attributeMode === 1){ // 多选
                            if(this.formAttributes[attributeId]){
                                this.formAttributes[attributeId].push(attributeValueId)
                            }else{
                                this.formAttributes[attributeId] = [attributeValueId]
                            }
                        }else if(attrObj.attributeMode === 4){ // 多选 + 输入
                            let _o = {
                                key:attributeValueId,
                                value:''
                            }
                            if(this.formAttributes[attributeId]){
                                this.formAttributes[attributeId].push(_o)
                            }else{
                                this.formAttributes[attributeId] = [_o]
                            }
                        }else{ // 单选
                            this.formAttributes[attributeId] = attributeValueId;
                        }
                    });
                }
            })
        }
    }
  },
  created(){
  },
  mounted() {
   
  },
};
</script>

<style lang="scss" scope>
.attributes_wrap{
    padding: 2px 10px;
    background: #fafafa;
    .attributes_list{
        display: flex;
        flex-wrap: wrap;
        .attributes_item{
            width: 33.33%;
            padding: 5px 10px;
        }
        .w100{
            width: 100%;
        }
    }
    .red{
        color:red;
    }
}
</style>